import SuggestedCURPError from './SuggestedCURPError';
class NotHasSuggestedCURP extends SuggestedCURPError {
    constructor(cause) {
        super('Investor not has a suggested CURP', cause);
    }
}
export default NotHasSuggestedCURP;
